import { apiGet, apiPatch } from './config';

export default class BoxSoftwareApi {
    static ModelName = 'boxsoftware';

    static async FetchAll() {
        return apiGet(`boxsoftware`);
    }

    static async CountNewSoftwareVersions() {
        return apiGet(`boxsoftware?status=new`);
    }

    static async ActiveNewVersion(payload) {
        return apiPatch(`boxsoftware/${payload.id}`, {
            boxsoftware: { ...payload.attributes, status: 'pending' },
        });
    }
}
